// Shared API call for src/services/*: shows the global loader while a request runs (unless silent),
// never throws, and resolves to { ok, body, paging, message, errorCode, activeRecord }.
import axios from "axios";
import { globals } from "../main";

let active = 0;
function showLoader() {
  active++;
  if (active === 1) globals.$loader?.show?.();
}
function hideLoader() {
  active = Math.max(0, active - 1);
  if (active === 0) globals.$loader?.hide?.();
}

// The single-active-record guard answers status:true with body.error { heading, message, active_record }
export async function apiCall(method, url, data, { silent = false } = {}) {
  if (!silent) showLoader();
  try {
    const res = method === "get"
      ? await axios.get(url, { params: data })
      : await axios[method](url, data);
    const payload = res.data || {};
    const guard = payload.body?.error;
    if (payload.status && guard) {
      return { ok: false, body: null, message: [guard.heading, guard.message].filter(Boolean).join(": "), activeRecord: guard };
    }
    return { ok: !!payload.status, body: payload.body, paging: payload.paging, message: payload.message || "", errorCode: payload.error_code };
  } catch (e) {
    return { ok: false, body: null, message: "Something went wrong. Please try again." };
  } finally {
    if (!silent) hideLoader();
  }
}
